import { DocumentTypeEntity } from './distribution-object';

export class DistributionObjectGroup {
    DistributionObjectGroupId: number;
    Name: string;
    Description: string;

    DistributionObjects: DocumentTypeEntity[];
}
